import { Grid } from '@chakra-ui/react'
import { Insurer } from 'BrokerTsLib/src/enums'
import React, { useEffect } from 'react'

import type { CompletedOverviewItemProps } from '@/components/CompletedOverview/CompletedOverviewItem'
import { Recap } from '@/components/Recap'
import { useSidebar } from '@/context/SidebarContext'
import type { PageSection } from '@/layouts/components/Sidebar'

import { CustomWaypoint } from '../../../../components/CustomWaypoint'
import { Loading } from '../../../../components/Loading'
import { useSelectedQuote } from '../../../../context/SelectedQuoteContext'
import { QuoteInformation } from '../../vehicle/StepComplete/forms/QuoteInformation'

export const StepComplete = () => {
  const { offer, isLoading: isLoadingOffer } = useSelectedQuote()
  const { setPageSections, pageSections } = useSidebar()

  // registrace sekcí
  useEffect(() => {
    if (!offer) return

    const array: PageSection[] = []
    let i = 1

    const additionalInfoData: CompletedOverviewItemProps[] = []
    if (offer.insurerId == Insurer.Allianz) {
      additionalInfoData.push({
        warning: `Upozornění pro poradce: ${offer.insurerNameFull} neumožňuje stažení dokumentu s názvem Návrh pojistné smlouvy.
                    Tento dokument bude na klienta i Vás jako poradce odeslán přímo od pojišťovny v samostatném e-mailu.`
      })
    }

    array.push(
      {
        id: 'recapitulation',
        sectionTitle: 'Rekapitulace pojištění',
        index: i++,
        children: !offer || isLoadingOffer
          ? <Loading large={true} />
          : (
            <CustomWaypoint sectionId="recapitulation" cardProps={{ sx: { gap: 16, pb: 16 } }}>
              <Recap id="recapitulation" sx={{ gap: 16, pb: 16 }}>
                <QuoteInformation offer={offer} additionalInfoData={additionalInfoData} />
              </Recap>
            </CustomWaypoint>
          )
      }
    )

    setPageSections(array)
  }, [offer, isLoadingOffer])


  return (
    <Grid sx={{ gap: 8 }}>
      {pageSections && pageSections.map(x => (
        <React.Fragment key={x.id}>
          {x.children}
        </React.Fragment>
      ))}
    </Grid >
  )
}